module.exports = __webpack_public_path__ + "img/QB-review.49d36712.png";